var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._t("default", function () {
        return [_vm._v(_vm._s(_vm.value.companyName))]
      }),
      _vm._v(" "),
      _vm.isDummyTrip
        ? _c("button", { staticClass: "btn-single-toggle is-active" }, [
            _vm._v("D"),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }